// extracted by mini-css-extract-plugin
export var arrowRight = "TechnologiesSlider-module--arrowRight--08711";
export var buttonRow = "TechnologiesSlider-module--buttonRow--64104";
export var cardsWrapper = "TechnologiesSlider-module--cardsWrapper--83bbf";
export var description = "TechnologiesSlider-module--description--692f4";
export var fadeInAnimation = "TechnologiesSlider-module--fadeInAnimation--88a09";
export var filterRow = "TechnologiesSlider-module--filterRow--06ee4";
export var itemIcon = "TechnologiesSlider-module--itemIcon--67abf";
export var itemLink = "TechnologiesSlider-module--itemLink--99734";
export var itemText = "TechnologiesSlider-module--itemText--fa3cb";
export var itemWrapper = "TechnologiesSlider-module--itemWrapper--db49b";
export var itemWrapperWithFilters = "TechnologiesSlider-module--itemWrapperWithFilters--803a7";
export var link = "TechnologiesSlider-module--link--895a9";
export var smallerMinHeight = "TechnologiesSlider-module--smallerMinHeight--e5fb9";
export var withFilter = "TechnologiesSlider-module--withFilter--eea81";
export var wrapper = "TechnologiesSlider-module--wrapper--751b0";